<template>
  <SoAlert
    v-if="switchTicket?.createdDate"
    class="mx-5 my-5"
    type="error"
    title="Account switched to Involuntary PAYG"
    data-testid="involuntary-payg-switched-banner-alert"
  >
    <p>
      This account was involuntarily switched to Smart PAYG on
      {{ formatDate(switchTicket?.createdDate) }}.
      <template v-if="switchTicket?.isRecentInvoluntaryPaygSwitch">
        If the customer is contacting about a recent switch, pass the call to
        PastDue - Customer to perform Safe and Reasonably Practicable checks.
      </template>
    </p>
  </SoAlert>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"
  import { formatDate } from "@/helpers/dateHelper"
  import { useCurrentAccountStore } from "@/stores/currentAccount"

  export default defineComponent({
    components: {
      SoAlert,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        formatDate,
      }
    },
    computed: {
      switchTicket() {
        return this.current.involuntaryPaygSwitchTicket.data
      },
    },
  })
</script>
